import { Flex, Text, Icon } from '@chakra-ui/react';
import { TbDatabaseSearch } from 'react-icons/tb';

export function SidebarBrand() {
	return (
		<Flex align='center' direction='row' gap='12px' mb='30px' mt='24px' px='8px'>
			<Flex
				align='center'
				justify='center'
				w='40px'
				h='40px'
				borderRadius='12px'
				bg='brand.500'
				boxShadow='0 6px 16px rgba(11, 79, 209, 0.45)'>
				<Icon as={TbDatabaseSearch} color='white' w='22px' h='22px' />
			</Flex>
			<Text color='white' fontSize='24px' fontWeight='800' letterSpacing='-1px'>
				Datric
			</Text>
		</Flex>
	);
}

export default SidebarBrand;
